const isRelatedDocumentsSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.RelatedDocumentsSection => {
  return s.sectionType === 'Related Documents';
};

export default isRelatedDocumentsSection;
